// SortingContext.jsx
import { createContext, useContext, useEffect, useState } from 'react';

const SortingContext = createContext();

export const SortingProvider = ({ properties, children, onOrderChange, columnFilterProperties, generalFilters }) => {
  const [order, setOrder] = useState([Object.keys(properties)[0]]);
  const [asc, setAsc] = useState({ [Object.keys(properties)[0]]: true });
  const [columnFilters, setColumnFilters] = useState(columnFilterProperties);
  const [filtersList , setFiltersList] = useState(generalFilters)

  const updateAsc = (key, ascending) => {
    setOrder(prev => (prev.includes(key) ? prev : [...prev, key]));
    setAsc(prev => ({ ...prev, [key]: ascending }));
  };

  const loopKey = (key) => {
    if (!(key in asc)) return updateAsc(key, true);
    if (asc[key]) return updateAsc(key, false);
    setOrder(prev => prev.filter(k => k !== key));
    setAsc(prev => {
      const updated = { ...prev };
      delete updated[key];
      return updated;
    });
  };

  const isAsc = (key) => asc[key] === true;
  const isDesc = (key) => asc[key] === false;
  
  useEffect(() => {
    onOrderChange?.(
      order.map((p) => `${p} ${asc[p] ? "asc" : "desc"}`).join(",")
    );
  }, [order, asc]);

  return (
    <SortingContext.Provider value={{
      order,
      asc,
      updateAsc,
      loopKey,
      isAsc,
      isDesc,
      setOrder,
      setAsc,
      properties,
      onOrderChange,
      columnFilters,
      filtersList,
      setFiltersList
    }}>
      {children}
    </SortingContext.Provider>
  );
};

export const useSorting = () => useContext(SortingContext);
